import { AutoTicket } from "../components/AutoTicket";

export default{
    init(){
        this.deleteingOrganisation();
        this.markAndRestoreDeletionOrganisation();
        this.initQbSyncTable();
    },

    deleteingOrganisation(){
        $('body').on('click','.org_delete_btn',function(e) {
            e.preventDefault();
            const org_id = $(this).data('org_id');
            $('#confirm_delete_organisation_modal').modal('show');
            $('#confirm_delete_organisation_modal').find('.confirm_delete_organisation').data('org_id', org_id);
        })
        $('#confirm_delete_organisation_modal').on('click', '.confirm_delete_organisation', function(e) {
            e.preventDefault();
            console.log($(e.target).data('org_id'), $(this).data('org_id'));
            const org_id = $(e.target).data('org_id');
            if (org_id > 0) {
                $.ajax({
                    type: 'POST',
                    url: '/admin/delete-team',
                    data: {
                        'organisation_id': org_id,
                    },
                    success: (response) => {
                        if (response.result == true) {
                            window.location.href = '/admin/admin-edit-team';
                        }
                    },
                    error: (response) => {
                        $('#confirm_delete_organisation_modal').modal('hide');
                        $('#error-deleting-organisation-modal').modal('show');
                        const auto_ticket = new AutoTicket('#error-deleting-organisation-modal', '.create-ticket-button');
                        if (response.message) {
                            $('#error-deleting-organisation-modal').find('.result_message').text(response.message);
                            auto_ticket.createAutoTicket("Something went wrong when deleting an organization", JSON.stringify(response.responseJSON.description));
                        }else{
                            auto_ticket.createAutoTicket("Something went wrong when deleting an organization", JSON.stringify(response.responseJSON.description));
                        }
                    }
                });
            }
        })
    },

    markAndRestoreDeletionOrganisation(){
        $('body').on('click', '.mark_as_deleted_organisation', (e) => {
            const target = $(e.currentTarget);
            const org_id = $(e.target).data('org_id');
            const url = '/admin/deletion-team';
            const reload = $(e.currentTarget).parents('.modal').length>0 ? false : true;
            const data = {
                organisation_id: org_id,
                action: 'delete',
            };
            this.sendRequest(url, data, (response)=> { 
                if (reload) {
                    window.location.reload(reload)
                } else {
                    target.text('Restore Deleting');
                    target.addClass('restore_deleting_organisation');
                    target.removeClass('mark_as_deleted_organisation');
                }
            });
        });
        $('body').on('click', '.restore_deleting_organisation', (e) => {
            const target = $(e.currentTarget);
            const org_id = $(e.target).data('org_id');
            const url = '/admin/deletion-team';
            const reload = $(e.currentTarget).parents('.modal').length>0 ? false : true;
            const data = {
                organisation_id: org_id,
                action: 'restore',
            };
            this.sendRequest(url, data, (response)=>{ 
                if (reload) {
                    window.location.reload(reload)
                } else {
                    target.text('Mark as Deleted');
                    target.addClass('mark_as_deleted_organisation');
                    target.removeClass('restore_deleting_organisation');
                }
            });
        });
    },

    initQbSyncTable() {
        const $this = this

        const updateOrganisationFixButton = () => {
            const selectedOrgId = $('select[name="selected_organisation_id"]').val()
            $('#check-fix-qb-org-btn').prop('disabled', !selectedOrgId)
        }

        $('body').on('change', 'select[name="selected_organisation_id"]', updateOrganisationFixButton);
        updateOrganisationFixButton();

        $('body').on('change', '.select-qb-obj, #select-qb-obj-all', function (ev) {
            if ($('.select-qb-obj:checked, #select-qb-obj-all:checked').length > 0)
                $('#resync-qb-btn').removeAttr('disabled');
            else
                $('#resync-qb-btn').attr('disabled', true);
        });

        $(document).on('fetch-table-data', (ev)=>{
            if(ev.detail?.selected_organisation_id){
                $('.stafter-table tr th:has(#select-qb-obj-all)').removeClass('d-none')
                $('.stafter-table tr td:has(.select-qb-obj)').removeClass('d-none')
            }else{
                $('.stafter-table tr th:has(#select-qb-obj-all)').addClass('d-none')
                $('.stafter-table tr td:has(.select-qb-obj)').addClass('d-none')
            }

            updateOrganisationFixButton();
        })

        $('body').on('click', '#resync-qb-btn', (ev)=>{
            const selectedOrgId = $('select[name="selected_organisation_id"]').val()

            $.ajax({
                type: 'POST',
                url: 'quickbooks-sync-list/check-connection',
                data: {
                    org_id: selectedOrgId
                },
                success: (response) => {
                    if(response?.connected){
                        $this.reSyncQbObjs();
                    }else if(response?.view){
                        $('#form-container').html(response.view);
                        $('#qb-sync-confirm-modal').modal('show');
                    }
                },
                error: (response) => {
                    
                },
            }); 
        })

        if (!window.BBAdminQbIntegrityWired) {
            window.BBAdminQbIntegrityWired = true;

            $('body').on('click', '#check-fix-qb-org-btn', () => {
                const selectedOrgId = $('select[name="selected_organisation_id"]').val()
                if (!selectedOrgId) return;

                $this.openQbIntegrityModal(selectedOrgId);
            });

            $('body').on('click', '#qb-integrity-apply-btn', function () {
                const selectedOrgId = $(this).data('org-id');
                if (!selectedOrgId) return;

                $this.applyQbIntegrityFix(selectedOrgId);
            });

            $('body').on('click', '#qb-integrity-recheck-btn', function () {
                const selectedOrgId = $(this).data('org-id');
                if (selectedOrgId) $this.openQbIntegrityModal(selectedOrgId);
            });
        }
    },

    openQbIntegrityModal(orgId) {
        $('#qb-integrity-apply-btn')
            .prop('disabled', true)
            .data('org-id', orgId)
            .removeData('repair-plan-id')
            .removeData('manifest-hash');
        $('#qb-integrity-recheck-btn').addClass('d-none').data('org-id', orgId);
        $('.qb-integrity-status').text('Scanning QuickBooks synced objects...');
        $('.qb-integrity-summary').empty();
        $('.qb-integrity-actions').empty();
        $('#qb-integrity-modal').modal('show');

        $.ajax({
            type: 'POST',
            url: 'quickbooks-sync-list/integrity-scan',
            data: { org_id: orgId },
            success: (response) => {
                this.renderQbIntegrityResult(response, false);
            },
            error: (response) => {
                this.renderQbIntegrityError(response.responseJSON?.message || 'QuickBooks integrity scan failed.');
            },
        });
    },

    applyQbIntegrityFix(orgId) {
        const $button = $('#qb-integrity-apply-btn');
        const repairPlanId = $button.data('repair-plan-id');
        const manifestHash = $button.data('manifest-hash');
        if (!repairPlanId || !manifestHash) {
            this.renderQbIntegrityError('The repair preview is missing. Scan again.');
            return;
        }

        $button.prop('disabled', true);
        $('.qb-integrity-status').text('Applying deterministic fixes...');

        $.ajax({
            type: 'POST',
            url: 'quickbooks-sync-list/integrity-fix',
            data: {
                org_id: orgId,
                repair_plan_id: repairPlanId,
                manifest_hash: manifestHash,
            },
            success: (response) => {
                this.renderQbIntegrityResult(response, true);
                $(document).trigger('refresh_stafter_table');
            },
            error: (response) => {
                this.renderQbIntegrityError(response.responseJSON?.message || 'QuickBooks integrity fix failed.');
            },
        });
    },

    renderQbIntegrityResult(response, applied) {
        const report = applied
            ? (response?.applied || response?.dry_run || {})
            : (response?.dry_run || response?.applied || {});
        const summary = report?.summary || {};
        const repairPlan = response?.repair_plan || null;
        const actions = repairPlan?.actions?.length
            ? repairPlan.actions
            : (report?.actions || []);
        const blocked = !!report?.blocked || response?.state === 'blocked';
        const canApply = !applied && !blocked && repairPlan?.can_approve === true;
        const reportActions = report?.actions || [];
        const hasRecheck = !applied && reportActions.concat(actions)
            .some((action) => action.recheck_available === true);

        $('.qb-integrity-status').text(response?.message || 'QuickBooks integrity check completed.');
        $('.qb-integrity-summary').html(this.qbIntegritySummaryHtml(
            summary,
            response?.state,
            repairPlan,
        ));
        $('.qb-integrity-actions').html(this.qbIntegrityActionsHtml(actions, response, report));
        $('#qb-integrity-apply-btn')
            .prop('disabled', !canApply)
            .data('repair-plan-id', repairPlan?.id || null)
            .data('manifest-hash', repairPlan?.manifest_hash || null)
            .text(canApply ? 'Approve & Apply' : 'Apply Fix');
        $('#qb-integrity-recheck-btn')
            .toggleClass('d-none', !hasRecheck)
            .prop('disabled', !hasRecheck)
            .data('org-id', $('#qb-integrity-apply-btn').data('org-id'));
    },

    renderQbIntegrityError(message) {
        $('.qb-integrity-status').text(message);
        $('.qb-integrity-summary').empty();
        $('.qb-integrity-actions').empty();
        $('#qb-integrity-apply-btn').prop('disabled', true);
        $('#qb-integrity-recheck-btn').addClass('d-none').prop('disabled', true);
    },

    qbIntegritySummaryHtml(summary, state, repairPlan = null) {
        const rows = [
            ['State', state || 'unknown'],
            ['Actions', summary.actions_total || 0],
            ['Approval-required actions', repairPlan?.approval_required_actions || 0],
            ['Manual review', summary.actions_manual_review || 0],
            ['Failed sync records', summary.failed_sync_objects || 0],
            ['Fixed sync records', summary.failed_sync_objects_fixed || 0],
            ['Payment issues', summary.payment_application_issues || 0],
            ['Deposit issues', summary.deposit_issues || 0],
            ['Invoice duplicate rows', summary.invoice_duplicate_rows || 0],
            ['Payment duplicate rows', summary.payment_duplicate_rows || 0],
            ['Deposit duplicate rows', summary.deposit_duplicate_rows || 0],
        ];

        return `<div class="qb-integrity-grid">${rows.map(([label, value]) => `
            <div class="qb-integrity-stat">
                <span>${label}</span>
                <strong>${value}</strong>
            </div>
        `).join('')}</div>`;
    },

    qbIntegrityActionsHtml(actions, response, report = {}) {
        if (!actions.length) {
            return '<div class="bb-banner bb-banner--success">No problematic synced objects were found.</div>';
        }

        const warnings = (report?.warnings || response?.warnings || [])
            .map((warning) => `<li>${this.escapeHtml(warning)}</li>`)
            .join('');

        const warningsHtml = warnings
            ? `<div class="bb-banner bb-banner--warning"><ul>${warnings}</ul></div>`
            : '';

        const actionRows = actions.map((action) => `
            <div class="qb-integrity-action">
                <div>
                    <strong>${this.escapeHtml(action.title || action.operation || action.action || 'QuickBooks action')}</strong>
                    <p>${this.escapeHtml(
                        action.reason
                        || (action.diffs || []).map((diff) =>
                            `${diff.field}: ${JSON.stringify(diff.actual)} → ${JSON.stringify(diff.expected)}`
                        ).join(' | ')
                        || action.next_action
                        || 'QuickBooks synced data does not match BizBaby data.'
                    )}</p>
                    ${action.next_action && action.reason !== action.next_action
                        ? `<p><strong>Next:</strong> ${this.escapeHtml(action.next_action)}</p>`
                        : ''}
                </div>
                <span>${this.escapeHtml(action.action_label || action.resolution || action.status || 'Requires admin review')}</span>
            </div>
        `).join('');

        return `${warningsHtml}<div class="qb-integrity-action-list">${actionRows}</div>`;
    },

    escapeHtml(value) {
        return String(value ?? '')
            .replaceAll('&', '&amp;')
            .replaceAll('<', '&lt;')
            .replaceAll('>', '&gt;')
            .replaceAll('"', '&quot;')
            .replaceAll("'", '&#039;');
    },

    reSyncQbObjs(){

        const blinkRow = (elem, success) =>{
            elem[0].style.setProperty('background-color', success ? '#3CD286' : '#EB5757', 'important')
            setTimeout(()=>{
                elem[0].style.setProperty('background-color', '')
            }, 300)
        }

        for (let elem of $('.select-qb-obj:checked')) {
            let preloader = $(elem).closest('td').find('.admin-row-preloader')
            let row = $(elem).closest('tr')
            $.ajax({
                type: 'POST',
                url: 'quickbooks-sync-list/resync-objects',
                data: {
                    qb_obj_id: $(elem).val()
                },
                beforeSend: () => {
                    preloader.removeClass('d-none')
                },
                success: (response) => {

                    blinkRow(row, response?.success)
                    preloader.addClass('d-none')
                },
                error: (response) => {
                    blinkRow(row, false)
                    preloader.addClass('d-none')
                },
            });
        }
    },

    /**
     *
     * @param {String} url
     * @param {Array} data
     * @param {String} type
     * @param {Function} successCallback
     * @param {Function} errorCallback
     */
    sendRequest(url, data, successCallback =()=>{}, errorCallback=()=>{}, type = 'POST'){
        $.ajax({
            type: type,
            url: url,
            data: data,
            success: (response)=>successCallback(response),
            error: (response)=>errorCallback(response),
        });
    }
}
